// extracted by mini-css-extract-plugin
export default {"partner":"style_partner__izSvZ","content":"style_content__1G8if","bg_main":"style_bg_main__Ydrmv","bg_top":"style_bg_top__Ic6dK"};